module.exports = __webpack_public_path__ + "static/media/dejoara.08dfc9b1.jpg";